import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { IcontactState } from "./interface";
import React from "react"

interface IAddProps {
  contactState: IcontactState,
  setContactState: (x: IcontactState) => void
}


const Edit = (props: IAddProps) => {

  //props
  const { contactState, setContactState } = props

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setContactState({ ...contactState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            style={{ width: "30%" }}
            size="small"
            name="libContact"
            label="libellé contact"
            value={contactState.libContact}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <TextField
            style={{ width: "30%" }}
            size="small"
            name="numero"
            label="Numéro"
            value={contactState.numero}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
    </Box>

  );
};
export default Edit;

